const countryCodes = (state = null, action) => {
  if (action.type === "SET_COUNTRY_CODES") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_COUNTRY_CODES": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default countryCodes;
